/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { invoicingControllerCreateInvoiceForBooking } from '../fn/invoicing/invoicing-controller-create-invoice-for-booking';
import { InvoicingControllerCreateInvoiceForBooking$Params } from '../fn/invoicing/invoicing-controller-create-invoice-for-booking';
import { invoicingControllerDeleteInvoice } from '../fn/invoicing/invoicing-controller-delete-invoice';
import { InvoicingControllerDeleteInvoice$Params } from '../fn/invoicing/invoicing-controller-delete-invoice';

@Injectable({ providedIn: 'root' })
export class InvoicingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `invoicingControllerCreateInvoiceForBooking()` */
  static readonly InvoicingControllerCreateInvoiceForBookingPath = '/invoicing/booking/{identifier}';

  /**
   * Genera la fattura per un booking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invoicingControllerCreateInvoiceForBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  invoicingControllerCreateInvoiceForBooking$Response(params: InvoicingControllerCreateInvoiceForBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invoicingControllerCreateInvoiceForBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * Genera la fattura per un booking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invoicingControllerCreateInvoiceForBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invoicingControllerCreateInvoiceForBooking(params: InvoicingControllerCreateInvoiceForBooking$Params, context?: HttpContext): Observable<void> {
    return this.invoicingControllerCreateInvoiceForBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invoicingControllerDeleteInvoice()` */
  static readonly InvoicingControllerDeleteInvoicePath = '/invoicing/{id}';

  /**
   * Elimina una fattura dal db.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invoicingControllerDeleteInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  invoicingControllerDeleteInvoice$Response(params: InvoicingControllerDeleteInvoice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invoicingControllerDeleteInvoice(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una fattura dal db.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invoicingControllerDeleteInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invoicingControllerDeleteInvoice(params: InvoicingControllerDeleteInvoice$Params, context?: HttpContext): Observable<void> {
    return this.invoicingControllerDeleteInvoice$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
